export enum EmailTypes {
    series = 'series',
    scheduled = 'scheduled',
    immediate = 'immediate'
}
